<div [class]="blockParent" [style.opacity]="isLoading ? '0.6' : '1'"
     [style.pointer-events]="isLoading ? 'none' : 'auto'">
  <div [class]="blockTitle">
    <div [class]="sliderClassName" [innerHTML]="sliderName"></div>
  </div>
  <div [class]="blockSlider" *ngIf="blockSliderLineOnOff">
    <div [class]="matSlider">
      <mat-slider [min]="localfs.minValueStart[item.type]" [max]="localfs.maxValueEnd[item.type]"
                  [disabled]="isLoading">
        <input [(ngModel)]="localfs.filterStart[item.type]" matSliderStartThumb
               (input)="onSliderInput(item.type, 'start', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
               (change)="onSliderChange(item.type, 'start', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])">
        <input [(ngModel)]="localfs.filterEnd[item.type]" matSliderEndThumb
               (input)="onSliderInput(item.type, 'end', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
               (change)="onSliderChange(item.type, 'end', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])">
      </mat-slider>
    </div>
  </div>
  <div [class]="blockInput">
    <div style="width: 100%;" [class]="inputBlock" appearance="outline" floatLabel="always">
      <input [class]="inputStart" [(ngModel)]="localfs.filterStart[item.type]"
             [min]="localfs.minValueStart[item.type]" [max]="localfs.maxValueEnd[item.type]" type="number"
             [disabled]="isLoading"
             (input)="onInputChange(item.type, 'start', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
             (change)="onSliderChange(item.type, 'start', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
             (blur)="validateAndCorrectInput(item.type, 'start')"
             (keydown.enter)="onSliderChange(item.type, 'start', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])">
    </div>
    <div [class]="inputline"></div>
    <div style="width: 100%;" [class]="inputBlock" appearance="outline" floatLabel="always">
      <input [class]="inputEnd" [(ngModel)]="localfs.filterEnd[item.type]"
             [min]="localfs.minValueStart[item.type]" [max]="localfs.maxValueEnd[item.type]"
             type="number" [disabled]="isLoading"
             (input)="onInputChange(item.type, 'end', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
             (change)="onSliderChange(item.type, 'end', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])"
             (blur)="validateAndCorrectInput(item.type, 'end')"
             (keydown.enter)="onSliderChange(item.type, 'end', localfs.minValueStart[item.type], localfs.maxValueEnd[item.type])">
    </div>
    <div [class]="inputClin"
         *ngIf="sliderChange(item.type)"
         (click)="onClearClick(item.type)"
         [style.opacity]="isLoading ? '0.5' : '1'"
         [style.cursor]="isLoading ? 'not-allowed' : 'pointer'">
      <mat-icon role="img" style="width: 100%; height: 100%;" aria-hidden="true" data-mat-icon-type="font">clear
      </mat-icon>
    </div>
  </div>
</div>
